import { gql } from "@apollo/client";

export const GET_AVAILABLE_RATE_GROUPS = gql`
  query getRateGroups(
    $input: AvailableRateGroupsInput!
    $from: Date!
    $until: Date!
    $filter: [RateGroupFilter!]
  ) {
    availableRateGroups(input: $input, filter: $filter) {
      id
      name
      code
      accommodationType {
        id
        name
        code
      }
      description
      isArchived
      isParcel
      guestCapacity
      guestAdditionalCapacity
      maxAvailability(from: $from, until: $until)
      translations {
        name
        description
        language
      }
      images {
        id
        url
        galleryPositionIndex
        isPrimary
      }
      ratePlans {
        id
        name
        description
        occupancy
        isArchived
        rateSellMode
        isAvailable(from: $from, until: $until)
        translations {
          name
          description
          language
        }
        defaultPriceBreakdown(from: $from, until: $until) {
          discountPercentage
          withDiscount
          withoutDiscount
        }
        parentPerPersonRatePlan {
          id
        }
        cancelationPolicy {
          id
          name
          description
          translations {
            name
            description
            language
          }
        }
        paymentConfig {
          paymentType
          downPaymentPercentage
        }
      }
      amenities {
        description
        value
        translations {
          description
          language
        }
      }
    }
  }
`;
